import React, { useRef, useCallback, useImperativeHandle, useState, useLayoutEffect, forwardRef } from 'react';
import styles from './FJAutoHeightTextarea.module.less';
import classNames from 'classnames';
const row_height = 22;

const FJAutoHeightTextarea = (props, ref) => {
    const {
        text = '',
        onChange,
        placeholder,
        minRow = 3,
        maxRow,
        className,
        inputClassName,
        maxLength,
        padding = 0,
    } = props;

    const _textareaRef = useRef(null);
    const _autoTextRef = useRef(null);
    const [value, setValue] = useState('');

    useImperativeHandle(ref, () => {
        return {
            focus: (cursorPosition = 0) => {
                _textareaRef.current.focus();
                if (cursorPosition !== -1) {
                    _textareaRef.current.selectionStart = cursorPosition;
                    _textareaRef.current.selectionEnd = cursorPosition;
                }
            },
            blur: () => {
                _textareaRef.current.blur();
            },
        };
    });

    useLayoutEffect(() => {
        const lastStr = text.slice(text.length - 1, text.length);
        // 最后一个字符为换行符的时候，div的高度不会包含最后的一行
        if (lastStr === '\n') {
            setValue(text + '#');
        } else {
            setValue(text);
        }
        _textareaRef.current.value = text;
    }, [text]);

    const _selectAll = useCallback(() => {
        _textareaRef.current.select();
    }, [_textareaRef.current]);

    const _onKeyDown = useCallback(
        e => {
            // ctrl + a
            if ((e.metaKey || e.ctrlKey) && 65 === e.keyCode) {
                _selectAll();
            }
        },
        [value, _selectAll],
    );

    const _onChange = useCallback(
        e => {
            onChange(e.target.value);
        },
        [value],
    );

    const heightStyle = {
        minHeight: minRow ? row_height * minRow + 'px' : '',
        maxHeight: maxRow ? row_height * maxRow + 'px' : '',
        padding: padding,
    };
    return (
        <div className={classNames(styles.box, className)}>
            <textarea
                className={classNames(styles.textarea, inputClassName)}
                placeholder={placeholder}
                onKeyDown={_onKeyDown}
                onChange={_onChange}
                maxLength={maxLength}
                ref={_textareaRef}
                style={{ ...heightStyle }}
            />
            <div className={styles.auto_box} ref={_autoTextRef} style={{ ...heightStyle }}>
                {value}
            </div>
        </div>
    );
};

export default forwardRef(FJAutoHeightTextarea);
